import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useRatSendCustomEventWithRef } from '@travel/traveler-core/hooks/useRat';

import { getSelectedNavSection } from 'store/providerInformation/selectors';

import { PC_TAB_OPEN_RAT_COMPID, SP_TAB_OPEN_RAT_COMPID } from '../constants';

/**
 * fires RAT custom event once per transition into new tab
 * pc = tab click or scroll
 * sp = tab click
 *
 * @param activeTabId - currently active tab ID, rat event is fired on state change
 * @param isSP - pc / sp
 */
export default function useTabOpenRatTracking(activeTabId: string, isSP: boolean) {
  const selectedNavSection = useSelector(getSelectedNavSection);
  const sendRatCustomEvent = useRatSendCustomEventWithRef();

  useEffect(() => {
    const compid = isSP
      ? SP_TAB_OPEN_RAT_COMPID[activeTabId]
      : PC_TAB_OPEN_RAT_COMPID[selectedNavSection?.id ?? ''];
    if (compid) {
      sendRatCustomEvent({ pData: { compid: [compid] }, eventType: 'appear' });
    }
  }, [activeTabId, isSP, selectedNavSection, sendRatCustomEvent]);
}
